import api from "./client";

export const getSuppliers = (params) => api.get("/suppliers", { params });
export const getSupplier = (supplierId) => api.get(`/suppliers/${supplierId}`);
export const createSupplier = (data) => api.post("/suppliers", data);
export const updateSupplier = (supplierId, data) => api.put(`/suppliers/${supplierId}`, data);
export const patchSupplier = (supplierId, data) => api.patch(`/suppliers/${supplierId}`, data);
export const deleteSupplier = (supplierId) => api.delete(`/suppliers/${supplierId}`);
export const confirmSupplierBankDetails = (supplierId) =>
  api.post(`/finance/suppliers/${supplierId}/bank-details/confirm`);
export const getSupplierProperties = (supplierId) => api.get(`/suppliers/${supplierId}/properties`);
export const getSupplierPipeline = () => api.get("/suppliers/pipeline");
export const updateSupplierPipelineStage = (id, data) => api.patch(`/suppliers/${id}/pipeline-stage`, data);
export const getSupplierSuggestions = (params) => api.get("/suppliers/suggestions", { params });
export const getSupplierPipelineTargets = (params) => api.get("/suppliers/pipeline/targets", { params });
export const dismissSupplierSuggestion = (id) => api.post(`/suppliers/${id}/dismiss-suggestion`);
export const sendPipelineOutreach = (data) => api.post("/suppliers/pipeline-outreach", data);
export const sendRegistrationInvite = (supplierId, sender = "piotr") => api.post(`/suppliers/${supplierId}/send-registration-invite?sender=${sender}`);

// Supplier profile read models: the supplier-side mirror of the client profile.
export const getSupplierProfileInsights = (supplierId) =>
  api.get(`/suppliers/${supplierId}/profile-insights`);
export const getSupplierAgedPayables = (supplierId, params) =>
  api.get(`/suppliers/${supplierId}/aged-payables`, { params });
export const getSupplierOutstandingInvoices = (supplierId, params) =>
  api.get(`/suppliers/${supplierId}/outstanding-invoices`, { params });
export const getSupplierCityBreakdown = (supplierId) =>
  api.get(`/suppliers/${supplierId}/city-breakdown`);
export const getSupplierContacts = (supplierId) =>
  api.get(`/suppliers/${supplierId}/contacts`);
export const addSupplierContact = (supplierId, data) =>
  api.post(`/suppliers/${supplierId}/contacts`, data);
export const updateSupplierContact = (supplierId, contactId, data) =>
  api.patch(`/suppliers/${supplierId}/contacts/${contactId}`, data);
export const deleteSupplierContact = (supplierId, contactId) =>
  api.delete(`/suppliers/${supplierId}/contacts/${contactId}`);
export const getSupplierContactCommunications = (supplierId) =>
  api.get(`/suppliers/${supplierId}/contact-communications`);
export const getSupplierGroupStructure = (supplierId) =>
  api.get(`/suppliers/${supplierId}/group-structure`);
export const getSupplierActivity = (supplierId, params) =>
  api.get(`/suppliers/${supplierId}/activity`, { params });
export const refreshSupplierHqAddress = (supplierId) => api.post(`/suppliers/${supplierId}/hq-address/refresh`);
